import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { MatChip, MatChipRemove } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

export interface SelectionChip {
  type: any;
  name: string;
  class?: string;
  removable?: boolean;
}

@Component({
  selector: 'bt-selection-chips',
  templateUrl: './selection-chips.component.html',
  styleUrl: './selection-chips.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatChip, MatChipRemove, MatIcon, TranslatePipe]
})
export class SelectionChipsComponent {
  chips = model<SelectionChip[]>([]);
  name = input<string>();
  type = input<string>();
  class = input<string>('default-chip selected-chip');

  standAlone = input<boolean>(false);
  enableAll = input<boolean>(false);
  totalCount = input<number>(0);
  allText = input<string>('All');

  removeChip(chipType: string) {
    this.chips.update((prev) => prev.filter((c) => c.type !== chipType));
  }
}
